import React from 'react';

export function AuthOrgBrandingLogo({ orgBranding }) {
  if (!orgBranding?.logo) return null;
  return (
    <div className="tw-mb-8 auth-logo">
      <img
        src={orgBranding.logo}
        alt={orgBranding.name || 'Organization'}
        className="tw-block tw-m-[0_auto] tw-max-w-[11.25rem] tw-max-h-[4.5rem] tw-w-auto tw-h-auto tw-object-contain auth-org-logo"
      />
    </div>
  );
}
